import { injectIntl } from "react-intl";
import React, { useEffect, useState } from "react";
import Header from "./Header";
import StrategyTable from "./StrategyTable";
import NewStrategy from "./NewStrategy";
import DeleteStrategy from "./DeleteStrategy";
import { PageEnum } from "src/helpers/Enums";
import apiService from "src/services/api.service";
import Empty from "../../../components/Empty";
import SearchNotFound from "src/components/SearchNotFound";
import SearchLine from "src/components/SearchLine";

const Strategies = () => {

    const [strategies, setStrategies] = useState([]);
    const [filteredStrategies, setFilteredStrategies] = useState([]);
    const [isNewStrategyOpen, setIsNewStrategyOpen] = useState(false);
    const [isDeleteStrategyOpen, setIsDeleteStrategyOpen] = useState(false);
    const [search, setSearch] = useState("");
    const [operationType, setOperationType] = useState();
    const [chosenStrategy, setChosenStrategy] = useState();
    const [isUpdate, setIsUpdate] = useState(true);

    useEffect(() => {
        if (isUpdate) {
            apiService.getAllStrategies().then((response) => {
                setStrategies(response.data)
            })
            setIsUpdate(false)
        }
    }, [isUpdate])

    useEffect(() => {
        const filtered = strategies?.filter((item) => {
            const itemName = item?.name?.toLowerCase?.() || '';
            const searchTerm = search?.toLowerCase?.() || '';
            return itemName.includes(searchTerm);
        });
        setFilteredStrategies(filtered || []);
    }, [search, strategies])

    const handleOpenNewStrategy = (operationType, strategy) => {
        setIsNewStrategyOpen(true)
        setOperationType(operationType)
        setChosenStrategy(strategy)
    }

    const handleOpenDeleteStrategy = (strategy) => {
        setIsDeleteStrategyOpen(true)
        setChosenStrategy(strategy)
    }

    const closeModals = () => {
        setIsDeleteStrategyOpen(false);
        setIsNewStrategyOpen(false)
        setIsUpdate(true)
    };

    return (
        <div className={ "Page" }>
            <Header handleOpenNewStrategy={ handleOpenNewStrategy } setSearch={ setSearch } search={ search }></Header>
            { search && <SearchLine setSearch={ setSearch } search={ search }></SearchLine> }
            { filteredStrategies?.length > 0 ?
                <div className={ "px-6 w-full h-full" }>
                    <StrategyTable handleOpenDeleteStrategy={ handleOpenDeleteStrategy }
                                   handleOpenNewStrategy={ handleOpenNewStrategy } list={ filteredStrategies }/>
                </div> : search ?
                    <SearchNotFound title={ "No Strategies Found" }
                                    description={ "No strategies match your search. Review your keywords or filters to refine your results." }></SearchNotFound> :
                    <Empty handleNew={ handleOpenNewStrategy } title={ "No Strategies Added Yet" }
                           description={ "Start by defining your goals and building a strategy to improve your results." }
                           type={ "Strategy" } menu={ PageEnum.STRATEGIES }
                    ></Empty>
            }
            { isNewStrategyOpen && <NewStrategy setIsNewStrategyOpen={ setIsNewStrategyOpen } type={ operationType }
                                                strategy={ chosenStrategy } close={ closeModals }/> }
            { isDeleteStrategyOpen &&
                <DeleteStrategy setIsDeleteStrategyOpen={ setIsDeleteStrategyOpen } strategy={ chosenStrategy }
                                close={ closeModals }/> }
        </div>
    );
}

export default injectIntl(Strategies);
